//@ts-nocheck
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
    Button,
    Card,
    Divider,
    Paper,
    Grid,
    Typography,
    TextField,
    CircularProgress,
    Alert,
    Collapse,
    Box,
    Stack,
    TablePagination,
    InputAdornment,
    IconButton,
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { secureGetItem } from "../../../utils/encryption";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import ToastApp from "../../../ToastApp";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import PrintIcon from "@mui/icons-material/Print";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import DocMngSwipeableDrawer from "./DocMngSwipeableDrawer";
import loged from "../../../assets/images/DrawerLogo2.png";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import { getSecureDevId, getSecureSubDeptId } from "../../../utils/storageHelpers";
interface MenuPermission {
    isAdd: boolean;
    isEdit: boolean;
    isPrint: boolean;
    isDel: boolean;
}


// --- Styled Components ---
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: `var(--header-background, #00009C)`,
        color: `var(--header-color, ${theme.palette.common.white})`,
        whiteSpace: 'nowrap',
        padding: '8px 12px',
        fontSize: '0.875rem',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: '0.8125rem',
        padding: '8px 12px',
        maxWidth: '200px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
    "& td, & th": {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
    "& td:last-child, & th:last-child": {
        borderRight: 0,
    }
}));

// Define types for filter options
interface FilterOption {
    label: string;
    value: number | string;
}


// Define types for PDF Preview Modal props
interface PdfPreviewModalProps {
    open: boolean;
    onClose: () => void;
    data: any[];
    filters: FormValues | null;
    totalRecords: number;
    logo: string;
    optionDivision: FilterOption[];
    optionSubSubject: FilterOption[];
    optionFileType: FilterOption[];
    optionSubDepartment: FilterOption[];
}

// --- PDF Preview Modal Component ---
const PdfPreviewModal: React.FC<PdfPreviewModalProps> = ({
    open,
    onClose,
    data,
    filters,
    totalRecords,
    logo,
    optionDivision,
    optionSubSubject,
    optionFileType,
    optionSubDepartment,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleDownload = () => {
        setIsLoading(true);
        setTimeout(() => {
            const contentElement = document.getElementById("pdf-preview-content");
            if (!contentElement) {
                toast.error("Could not find content to download.");
                setIsLoading(false);
                return;
            }

            const printWindow = window.open("", "_blank");
            if (!printWindow) {
                toast.error("Could not open download window. Check browser pop-up blocker.");
                setIsLoading(false);
                return;
            }

            const clonedContent = contentElement.cloneNode(true) as HTMLElement;

            const styles = `
                <style>
                    body {
                        font-family: 'Times New Roman', serif;
                        margin: 0;
                        padding: 20px;
                        color: #000;
                        background: #fff;
                        font-size: 13px;
                    }
                    .report-header {
                        display: flex;
                        align-items: center;
                        margin-bottom: 15px;
                        border-bottom: 2px solid #000080;
                        padding-bottom: 6px;
                    }
                    .report-header img {
                        height: 80px !important; /* Bigger logo only in print */
                    }
                    .report-title {
                        margin-left: 20px;
                        color: #000080;
                    }
                    .report-title h1 {
                        font-size: 22px !important;
                        margin: 0;
                        font-weight: bold;
                    }
                    .report-title small {
                        font-size: 12px;
                        color: #333;
                    }
                    .report-meta {
                        margin-bottom: 15px;
                        padding: 4px 5px;
                        border: 1px solid #000;
                        background: #f9f9f9;
                        font-size: 12px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        gap: 5px;
                    }
                    .report-meta p, 
                    .report-meta span, 
                    .report-meta div {
                        margin: 0;
                        display: inline-block; /* ✅ Prevent stacking */
                    }
                    .report-table {
                        width: 100%;
                        border: 1px solid #000;
                        border-collapse: collapse;
                        margin-bottom: 15px;
                    }
                    .report-table th,
                    .report-table td {
                        border: 1px solid #000;
                        padding: 6px;
                        font-size: 12px;
                        text-align: left;
                    }
                    .report-table th {
                        background: #000080;
                        color: #fff;
                        font-weight: bold;
                        text-transform: uppercase;
                        font-size: 11px;
                    }
                    .report-footer {
                        margin-top: 20px;
                        padding-top: 6px;
                        border-top: 1px solid #000;
                        text-align: right;
                        font-size: 11px;
                    }
                    .logo-watermark {
                        position: fixed;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        opacity: 0.07;
                        width: 300px;
                        height: 300px;
                        background-image: url('${logo}');
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                        pointer-events: none;
                        z-index: -1;
                    }
                </style>
            `;

            printWindow.document.write(`
                <html>
                    <head>
                        <title>Official Report - ${moment(new Date()).format("DD/MM/YYYY")}</title>
                        ${styles}
                    </head>
                    <body>
                        <div class="logo-watermark"></div>
                        ${clonedContent.outerHTML}
                    </body>
                </html>
            `);

            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                setIsLoading(false);
                toast.success("PDF is ready for printing");
            }, 500);
        }, 1000);
    };

    const getFilterDescription = () => {
        if (!filters) return "All Records";
        let description = "";
        if (filters.divisionid && filters.divisionid !== -1) {
            const department = optionDivision.find(d => d.value === filters.divisionid);
            if (department) description += `Department: ${department.label}, `;
        }
        if (filters.subDeptID && filters.subDeptID !== -1) {
            const subDepartment = optionSubDepartment.find(s => s.value === filters.subDeptID);
            if (subDepartment) description += `Sub-Department: ${subDepartment.label}, `;
        }
        if (filters.subsubjId && filters.subsubjId !== -1) {
            const subject = optionSubSubject.find(s => s.value === filters.subsubjId);
            if (subject) description += `Subject: ${subject.label}, `;
        }
        if (filters.fileTypId && filters.fileTypId !== -1) {
            const fileType = optionFileType.find(f => f.value === filters.fileTypId);
            if (fileType) description += `File Type: ${fileType.label}, `;
        }
        if (filters.fileNo) description += `File No: ${filters.fileNo}, `;
        if (filters.perFr && filters.perUt) description += `Period: ${filters.perFr} - ${filters.perUt}, `;
        return description ? description.replace(/,\s*$/, "") : "All Records";
    };

    return (
       <Dialog
  open={open}
  onClose={onClose}
  fullScreen={window.innerWidth < 600}   // ✅ mobile full screen
  maxWidth="md"                          // ✅ lg hatao
  fullWidth
  PaperProps={{
    sx: {
      height: { xs: "100vh", sm: "90vh" },   // ✅ mobile full height
      maxHeight: "100vh",
      m: { xs: 0, sm: 2 },                   // ✅ mobile margin remove
      borderRadius: { xs: 0, sm: 2 },
    }
  }}
>
            {/* Header */}
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "#000080",
                    color: "white",
                     px: { xs: 1, sm: 2 },
    py: 1,
    overflow: "auto",     // ✅ scroll fix
                }}
            >
                <Box display="flex" alignItems="center">
                    <PictureAsPdfIcon sx={{ mr: 1, color: "white" }} />
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        Official Document Report
                    </Typography>
                </Box>
                <IconButton onClick={onClose} sx={{ color: "white" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            {/* Content */}
            <DialogContent
                dividers
                sx={{
                    background: "#fff",
                    px: 2,
                    py: 1.5,
                }}
            >
                {/* Watermark */}
                <Box
                    className="no-print"
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        opacity: 0.07,
                        width: "300px",
                        height: "300px",
                        backgroundImage: `url(${logo})`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        pointerEvents: "none",
                        zIndex: -1
                    }}
                />

                <Box id="pdf-preview-content">
                    {/* Report Header */}
                <Box
  className="report-header"
  sx={{
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1.5,
  }}
>
  <img
    src={logo}
    alt="Logo"
    style={{
      maxHeight: "45px",     // 👈 thoda chhota for mobile
      width: "auto",
      objectFit: "contain",
    }}
  />

  <Typography
    sx={{
      fontSize: { xs: "16px", sm: "20px" },  // ✅ responsive text
      fontWeight: "bold",
      color: "#000080",
    }}
  >
    Document Report
  </Typography>
</Box>
                    {/* Filters */}
                    {/* <Box className="report-meta"  sx={{
    display: "flex",
    flexDirection: "column",   // ✅ force vertical
    gap: 1,
  }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 0.5 }}>
                            Report Filters
                        </Typography>
                        <Typography variant="body2">{getFilterDescription()}</Typography>
                        <Typography variant="body2" sx={{ mt: 0.5, fontWeight: "bold" }}>
                            Total Records: {totalRecords}
                        </Typography>
                    </Box> */}

                    {/* Table */}
                    <Box sx={{ overflowX: "auto" }}>
<table
    className="report-table"
    style={{
      minWidth: "800px",   // ✅ horizontal scroll enable
      width: "100%",
      borderCollapse: "collapse"
    }}
  >
                        <thead>
                            <tr>
                                <th>Sr No</th>
                                <th>File Name</th>
                                <th>Department</th>
                                {/* <th>Subject</th> */}
                                <th>File No</th>
                                <th>File Type</th>
                                <th>Sub Subject</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{row.synopsis || "N/A"}</td>
                                    <td>{row.department_Name || "-"}</td>
                                    {/* <td>{row.sub_Subject_Name || "-"}</td> */}
                                    <td>{row.fileNo || "-"}</td>
                                    <td>{row.fileType_Name || "-"}</td>
                                    <td>{row.sub_Subject_Name || "-"}</td>
                                    <td>{row.createdate ? moment(row.createdate).format("DD/MM/YYYY") : "-"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
</Box>

                    {/* Footer */}
                    <Box className="report-footer" sx={{ mt: 3, borderTop: "1px solid #000", pt: 1, textAlign: "right" }}>
                        <Typography variant="body2">Generated On: {moment(new Date()).format("DD/MM/YYYY")}</Typography>
                        <Typography variant="body2">Page 1 of 1</Typography>
                    </Box>
                </Box>
            </DialogContent>

            {/* Actions */}
            <DialogActions
                sx={{
                    justifyContent: "space-between",
                    p: 1.5,
                    borderTop: "1px solid #000"
                }}
            >
                <Typography variant="body2" color="textSecondary">
                    Total Records: {totalRecords}
                </Typography>
                <Box>
                    <Button onClick={onClose} sx={{ mr: 1 }} variant="outlined" color="inherit">
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        sx={{ backgroundColor: "#000080", "&:hover": { backgroundColor: "#000066" } }}
                        startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : <DownloadIcon />}
                        onClick={handleDownload}
                        disabled={isLoading}
                    >
                        {isLoading ? "Preparing..." : "Download PDF"}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

// --- Row Component ---
function Row({ row, index, onRowClick }: { row: any; index: number, onRowClick: (rowData: any) => void }) {
    const handleFileNameClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        onRowClick(row);
    };

    return (
        <StyledTableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
            <StyledTableCell align="center">{index + 1}</StyledTableCell>
            <StyledTableCell>
                <a
                    href="#"
                    style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                    onClick={handleFileNameClick}
                >
                    {row.synopsis || 'N/A'}
                </a>
            </StyledTableCell>
             <StyledTableCell title={row.department_Name}>{row.department_Name || '-'}</StyledTableCell>
             <StyledTableCell>{row.fileNo || '-'}</StyledTableCell>
    
    
            <StyledTableCell>{row.fileType_Name || '-'}</StyledTableCell>
            <StyledTableCell title={row.sub_Subject_Name}>{row.sub_Subject_Name || '-'}</StyledTableCell>
           
            <StyledTableCell>
                {row.createdate ? new Date(row.createdate).toLocaleDateString() : '-'}
            </StyledTableCell>
        </StyledTableRow>
    );
}

// --- Main Component ---
const API_ENDPOINT = HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`;
const DEFAULT_FILTER_INT = -1;
const DEFAULT_FILTER_STRING = "";

// Define FormValues interface
interface FormValues {
    docMid: number | null | string;
    fileTypId: number | null | string;
    divisionid: number | null | string;
    subDeptID: number | null | string;
    subsubjId: number | null | string;
    user_Id: number | null | string;
    fileNo: string | null;
    perFr: string;
    perUt: string;
    complt: string | null;
}

export default function DocManagerReports() {
    const { t } = useTranslation();
    const [filterDrawerOpen, setFilterDrawerOpen] = useState(true);
    const [data, setData] = useState<any[]>([]);
    const [filteredData, setFilteredData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [detailsDrawerOpen, setDetailsDrawerOpen] = useState(false);
    const [pdfModalOpen, setPdfModalOpen] = useState(false);
    const [currentFilters, setCurrentFilters] = useState<FormValues | null>(null);
const [permissionLoaded, setPermissionLoaded] = useState(false);
const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
});
const location = useLocation();
    // ✅ Debounce timer for file number
    const debounceTimer = useRef<NodeJS.Timeout | null>(null);

    // Pagination state
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // Search state
    const [searchTerm, setSearchTerm] = useState("");

    // Filter dropdowns state
    const [optionSubSubject, setOptionSubSubject] = useState<FilterOption[]>([]);
    const [optionDivision, setOptionDivision] = useState<FilterOption[]>([]);
    const [optionSubDepartment, setOptionSubDepartment] = useState<FilterOption[]>([]);
    const [optionFileType, setOptionFileType] = useState<FilterOption[]>([]);
    const [optionFileNo, setOptionFileNo] = useState<FilterOption[]>([]);

    // Loading states
    const [loadingSubDepartments, setLoadingSubDepartments] = useState(false);
    const [initialized, setInitialized] = useState(false);

    // Static Options
    const statusOption = [
        { value: "1", label: t("text.Process") },
        { value: "2", label: t("text.Pending") },
        { value: "3", label: t("text.Complete") },
    ];

    // Get secure IDs
    const devId = getSecureDevId();
    const subDeptID = getSecureSubDeptId();

    // Convert to numbers safely
    const devIdNum = devId && devId !== "null" && devId !== "undefined" ? Number(devId) : -1;
    const subDeptIDNum = subDeptID && subDeptID !== "null" && subDeptID !== "undefined" ? Number(subDeptID) : -1;

    // Check if devId is present but subDeptID is not present
    const isDevIdOnlyPresent = devIdNum !== -1 && subDeptIDNum === -1;
    const areBothSecureIdsPresent = devIdNum !== -1 && subDeptIDNum !== -1;

    // Handle pagination
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Handle search
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);

        if (term === "") {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item =>
                Object.values(item).some(val =>
                    val && val.toString().toLowerCase().includes(term)
                )
            );
            setFilteredData(filtered);
        }
        setPage(0);
    };
    useEffect(() => {
        const data = secureGetItem("userdata");

        if (data && data.length > 0) {
            const userPermissionData = data[0]?.userPermission;
            const menudata = userPermissionData?.[0]?.parentMenu || [];

            for (let i = 0; i < menudata.length; i++) {
                const childMenudata = menudata[i]?.childMenu || [];
                const pathrow = childMenudata.find(
                    (x: any) => x.path === location.pathname
                );

                if (pathrow) {
                    setPermissionData({
                        isAdd: pathrow.isAdd,
                        isEdit: pathrow.isEdit,
                        isPrint: pathrow.isPrint,   // ✅ Print permission
                        isDel: pathrow.isDel,
                    });
                    break;
                }
            }
        }

        setPermissionLoaded(true);
    }, [location.pathname]);
    // Apply search when data changes
    useEffect(() => {
        if (searchTerm) {
            const filtered = data.filter(item =>
                Object.values(item).some(val =>
                    val && val.toString().toLowerCase().includes(searchTerm)
                )
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(data);
        }
    }, [data, searchTerm]);

    // Fetch sub-departments when department changes
    const fetchSubDepartments = useCallback(async (deptId: number, setDefaultValue: boolean = false) => {
        if (deptId === -1) {
            setOptionSubDepartment([]);
            return;
        }

        setLoadingSubDepartments(true);
        try {
            const response = await axios.post(HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`, {
                subDeptID: -1,
                deptID: deptId
            });

            if (response.data.isSuccess) {
                const subDepartments = response.data.data || [];
                const options = subDepartments.map((item: any) => ({
                    label: item.subDeptName,
                    value: item.subDeptID
                }));
                setOptionSubDepartment(options);

                // If this is the initial load with both secure IDs present, find and set the sub-department
                if (setDefaultValue && areBothSecureIdsPresent && subDeptIDNum !== -1) {
                    const foundSubDept = options.find(opt => opt.value === subDeptIDNum);
                    if (foundSubDept) {
                        formik.setFieldValue("subDeptID", foundSubDept.value);
                        // ✅ Auto filter after setting sub-department
                        setTimeout(() => {
                            fetchData({
                                ...formik.values,
                                subDeptID: foundSubDept.value
                            });
                        }, 100);
                    }
                }
                // If only devId is present, don't set any default value (leave it empty)
            } else {
                setOptionSubDepartment([]);
            }
        } catch (error: any) {
            console.error("Error fetching sub-departments:", error);
            setOptionSubDepartment([]);
        } finally {
            setLoadingSubDepartments(false);
        }
    }, [areBothSecureIdsPresent, subDeptIDNum]);

    // Fetch Data Function
    const fetchData = useCallback(async (filterParams: FormValues) => {
        setLoading(true);
        setError(null);
        setData([]);
        console.log("Fetching data with params:", filterParams);
        setCurrentFilters(filterParams);

        const payload = {
            docMid: filterParams.docMid || DEFAULT_FILTER_INT,
            fileTypId: filterParams.fileTypId || DEFAULT_FILTER_INT,
            divisionid: filterParams.divisionid !== null && filterParams.divisionid !== undefined
                ? Number(filterParams.divisionid)
                : DEFAULT_FILTER_INT,
            subDeptID: filterParams.subDeptID !== null && filterParams.subDeptID !== undefined
                ? Number(filterParams.subDeptID)
                : DEFAULT_FILTER_INT,
            subsubjId: filterParams.subsubjId || DEFAULT_FILTER_INT,
            user_Id: filterParams.user_Id || DEFAULT_FILTER_INT,
            fileNo: filterParams.fileNo || DEFAULT_FILTER_STRING,
            perFr: filterParams.perFr || DEFAULT_FILTER_STRING,
            perUt: filterParams.perUt || DEFAULT_FILTER_STRING,
            complt: filterParams.complt || DEFAULT_FILTER_STRING,
            synopsis: "",
        };

        try {
            const response = await axios.post(API_ENDPOINT, payload);
            if (response.data.isSuccess) {
                setData(response.data.data || []);
                if (!response.data.data || response.data.data.length === 0) {
                    toast.info(t("text.NoDataFound"));
                }
            } else {
                setError(response.data.mesg || t("text.ErrorFetchingData"));
                toast.error(response.data.mesg || t("text.ErrorFetchingData"));
            }
        } catch (err: any) {
            console.error("API Error:", err);
            const errorMsg = err.response?.data?.mesg || err.message || t("text.NetworkError");
            setError(errorMsg);
            toast.error(errorMsg);
        } finally {
            setLoading(false);
        }
    }, [t]);

    // Fetch Initial Data and Dropdown Data
    useEffect(() => {
        const initializeData = async () => {
            try {
                // First, fetch all dropdown data
                const subSubjRes = await axios.post(HOST_URL.HOST_URL2 + "SubSubjForPdf/GetSubSubjForPdf", { sSubId: -1 });
                setOptionSubSubject(subSubjRes.data.data.map((item: any) => ({ label: item.subSubj, value: item.sSubId })) || []);

                // Division
                const divisionRes = await axios.post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`,
                    {
                        id: devId == null ? -1 : Number(devId),
                        nodeID: -1,
                        titleID: -1
                    });
                const departmentOptions = divisionRes.data.data.map((item: any) => ({ label: item.name, value: item.id })) || [];
                setOptionDivision(departmentOptions);

                // File Type
                const fileTypeRes = await axios.post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, { docID: -1, parentDocId: -1, userId: "" });
                setOptionFileType(fileTypeRes.data.data.map((item: any) => ({ label: item.doc_Name, value: item.docID })) || []);

                // Initialize form values based on what secure IDs are present
                const initialValues: FormValues = {
                    docMid: null,
                    fileTypId: null,
                    divisionid: devIdNum !== -1 ? devIdNum : (devId ? Number(devId) : -1),
                    subDeptID: areBothSecureIdsPresent ? subDeptIDNum : null,
                    subsubjId: null,
                    user_Id: null,
                    fileNo: null,
                    perFr: "",
                    perUt: "",
                    complt: null,
                };

                // Set form values
                formik.setValues(initialValues);

                // If devId is present (regardless of subDeptID), fetch sub-departments for that department
                if (devIdNum !== -1) {
                    // Find the department in options
                    const foundDept = departmentOptions.find(dept => dept.value === devIdNum);
                    if (foundDept) {
                        // Fetch sub-departments for this department
                        // Only set default value if both secure IDs are present
                        await fetchSubDepartments(devIdNum, areBothSecureIdsPresent);
                    }
                }

                // Now fetch the initial data
                await fetchData(initialValues);

                // File Number options will be populated after data is fetched
                setInitialized(true);

            } catch (error) {
                console.error("Error fetching dropdown data:", error);
                toast.error(t("text.ErrorFetchingFilters"));
            }
        };

        initializeData();
    }, [devId, subDeptID, fetchData, t, fetchSubDepartments]);

    // Update file number options when data changes
    useEffect(() => {
        if (data.length > 0 && initialized) {
            const distinctFileNos = Array.from(new Set(data.map((item: any) => item.fileNo).filter(Boolean)));
            setOptionFileNo(distinctFileNos.map((fileNo: string) => ({ label: fileNo, value: fileNo })) || []);
        }
    }, [data, initialized]);

    const initialValues: FormValues = {
        docMid: null,
        fileTypId: null,
        divisionid: devIdNum !== -1 ? devIdNum : (devId ? Number(devId) : -1),
        subDeptID: areBothSecureIdsPresent ? subDeptIDNum : null,
        subsubjId: null,
        user_Id: null,
        fileNo: null,
        perFr: "",
        perUt: "",
        complt: null,
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: async (values) => {
            console.log("Submitting filters:", values);
            await fetchData(values);
        },
        enableReinitialize: true, // ✅ Important for auto filter
    });

    // Handle department change to fetch sub-departments
    const handleDepartmentChange = (event: any, newValue: FilterOption | null) => {
        formik.setFieldValue("divisionid", newValue?.value ?? null);
        formik.setFieldValue("subDeptID", null); // Clear sub-department when department changes

        if (newValue?.value) {
            fetchSubDepartments(Number(newValue.value), false);
        } else {
            setOptionSubDepartment([]);
        }

        // ✅ Auto filter after department change
        setTimeout(() => {
            fetchData({
                ...formik.values,
                divisionid: newValue?.value ?? null,
                subDeptID: null
            });
        }, 100);
    };

    // Event Handlers
    const handleFilterButtonClick = () => {
        setFilterDrawerOpen((prev) => !prev);
    };

    const handleRowClick = (rowData: any) => {
        setSelectedRow(rowData);
        setDetailsDrawerOpen(true);
    };

    const handleDetailsDrawerClose = () => {
        setDetailsDrawerOpen(false);
        setSelectedRow(null);
    };

    const handlePrintPreview = () => {
        setPdfModalOpen(true);
    };

    const handleClear = () => {
        // Reset form values based on what secure IDs are present
        const resetValues: FormValues = {
            docMid: null,
            fileTypId: null,
            divisionid: devIdNum !== -1 ? devIdNum : null,
            subDeptID: areBothSecureIdsPresent ? subDeptIDNum : null,
            subsubjId: null,
            user_Id: null,
            fileNo: null,
            perFr: "",
            perUt: "",
            complt: null,
        };

        formik.setValues(resetValues);

        // If devId is present, fetch sub-departments for that department
        if (devIdNum !== -1) {
            // Only set default value if both secure IDs are present
            fetchSubDepartments(devIdNum, areBothSecureIdsPresent);
        } else {
            setOptionSubDepartment([]);
        }

        fetchData(resetValues);
        setSearchTerm("");
        toast.info(t("text.FiltersCleared"));
    };

    return (
        <>
            <ToastApp />
            <Card
                style={{
                    width: "100%",
                    backgroundColor: "var(--page-background-color, #E9FDEE)",
                    border: ".5px solid #ccc",
                    marginTop: "2vh",
                }}
            >
                <Paper
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                        position: 'relative',
                        backgroundImage: `url(${loged})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: '300px',
                        backgroundBlendMode: 'lighten',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    }}
                    style={{ padding: "15px" }}
                >
                    {/* Header Section */}
                    <Grid container justifyContent="space-between" alignItems="center" sx={{ padding: "10px 20px" }}>
                        <Grid item>
                            <Typography variant="h5" component="div">
                                {t("text.DocManagerReport")}
                            </Typography>
                        </Grid>
                        <Grid item sx={{ display: 'flex', gap: 2 }}>
                            <Button
                                variant="contained"
                                startIcon={<FilterAltIcon />}
                                onClick={handleFilterButtonClick}
                                className="no-print"
                                sx={{ textTransform: 'none' }}
                            >
                                {t("text.Filter")}
                            </Button>
                            {permissionData?.isPrint && (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<PrintIcon />}
                                    onClick={handlePrintPreview}
                                    className="no-print"
                                    sx={{ textTransform: 'none' }}
                                    disabled={loading || data.length === 0}
                                >
                                    {t("text.PrintPreview")}
                                </Button>
                            )}
                        </Grid>
                    </Grid>

                    {/* Filter Drawer */}
                    <Collapse in={filterDrawerOpen} timeout="auto" unmountOnExit className="no-print">
                        <Card variant="outlined" sx={{ p: 1, mb: 1, backgroundColor: 'background.paper' }}>
                            <Typography variant="subtitle1" gutterBottom sx={{ mb: 1, fontWeight: 'small' }}>
                                {t("text.FilterOptions")}
                            </Typography>
                            <Box component="form" onSubmit={formik.handleSubmit} id="filter-collapse-content">
                                <Grid container spacing={2.5}>
                                    {/* Filter Inputs */}
                                    <Grid item xs={12} sm={6} md={3}>
                                        <Autocomplete
                                            disablePortal
                                            options={optionDivision}
                                            getOptionLabel={(option) => option.label || ""}
                                            fullWidth
                                            size="small"
                                            value={optionDivision.find(opt => opt.value === formik.values.divisionid) || null}
                                            onChange={handleDepartmentChange}
                                            disabled={devIdNum !== -1} // Disable if devId is present (regardless of subDeptID)
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t("text.selectDet")}
                                                    placeholder={
                                                        devIdNum !== -1
                                                            ? "Pre-selected from secure ID"
                                                            : "Select department"
                                                    }
                                                />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        />
                                    </Grid>

                                    {/* Sub-Department Filter */}
                                    {/* <Grid item xs={12} sm={6} md={3}>
                                        <Autocomplete
                                            disablePortal
                                            options={optionSubDepartment}
                                            getOptionLabel={(option) => option.label || ""}
                                            fullWidth
                                            size="small"
                                            value={optionSubDepartment.find(opt => opt.value === formik.values.subDeptID) || null}
                                            onChange={(event, newValue) => {
                                                formik.setFieldValue("subDeptID", newValue?.value ?? null);
                                                // ✅ Auto filter after sub-department change
                                                setTimeout(() => {
                                                    fetchData({
                                                        ...formik.values,
                                                        subDeptID: newValue?.value ?? null
                                                    });
                                                }, 100);
                                            }}
                                            disabled={
                                                !formik.values.divisionid ||
                                                areBothSecureIdsPresent || // Disable if both secure IDs are present
                                                loadingSubDepartments
                                            }
                                            loading={loadingSubDepartments}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t("text.subDeptName") || "Sub-Department"}
                                                    placeholder={
                                                        areBothSecureIdsPresent
                                                            ? "Pre-selected from secure ID"
                                                            : isDevIdOnlyPresent
                                                                ? "Select sub-department (optional)"
                                                                : formik.values.divisionid
                                                                    ? "Select sub-department"
                                                                    : "Select department first"
                                                    }
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {loadingSubDepartments ? <CircularProgress size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        />
                                    </Grid> */}

                                    <Grid item xs={12} sm={6} md={3}>
                                        <Autocomplete
                                            disablePortal
                                            options={optionSubSubject}
                                            getOptionLabel={(option) => option.label || ""}
                                            fullWidth
                                            size="small"
                                            value={optionSubSubject.find(opt => opt.value === formik.values.subsubjId) || null}
                                            onChange={(event, newValue) => {
                                                formik.setFieldValue("subsubjId", newValue?.value ?? null);
                                                // ✅ Auto filter after sub-subject change
                                                setTimeout(() => {
                                                    fetchData({
                                                        ...formik.values,
                                                        subsubjId: newValue?.value ?? null
                                                    });
                                                }, 100);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label={t("text.SelectSubSubject")} />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <Autocomplete
                                            disablePortal
                                            options={optionFileType}
                                            getOptionLabel={(option) => option.label || ""}
                                            fullWidth
                                            size="small"
                                            value={optionFileType.find(opt => opt.value === formik.values.fileTypId) || null}
                                            onChange={(event, newValue) => {
                                                formik.setFieldValue("fileTypId", newValue?.value ?? null);
                                                // ✅ Auto filter after file type change
                                                setTimeout(() => {
                                                    fetchData({
                                                        ...formik.values,
                                                        fileTypId: newValue?.value ?? null
                                                    });
                                                }, 100);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label={t("text.SelectFileType")} />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <Autocomplete
                                            freeSolo
                                            disablePortal
                                            options={optionFileNo}
                                            getOptionLabel={(option) => typeof option === 'string' ? option : option.label || ""}
                                            fullWidth
                                            size="small"
                                            value={optionFileNo.find(opt => opt.value === formik.values.fileNo) || formik.values.fileNo || null}
                                            onChange={(event, newValue) => {
                                                const fileNoValue = typeof newValue === 'string' ? newValue : newValue?.value ?? null;
                                                formik.setFieldValue("fileNo", fileNoValue);
                                                // ✅ Clear any pending timer
                                                if (debounceTimer.current) {
                                                    clearTimeout(debounceTimer.current);
                                                }
                                                // ✅ Auto filter with debounce for file number
                                                debounceTimer.current = setTimeout(() => {
                                                    fetchData({
                                                        ...formik.values,
                                                        fileNo: fileNoValue
                                                    });
                                                }, 500);
                                            }}
                                            onInputChange={(event, newInputValue) => {
                                                // For freeSolo typing
                                                if (debounceTimer.current) {
                                                    clearTimeout(debounceTimer.current);
                                                }
                                                debounceTimer.current = setTimeout(() => {
                                                    formik.setFieldValue("fileNo", newInputValue);
                                                    fetchData({
                                                        ...formik.values,
                                                        fileNo: newInputValue
                                                    });
                                                }, 800);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label={t("text.SelectOrEnterFileNo")} />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        />
                                    </Grid>

                                    {/* Filter Actions - Only Clear button now */}
                                    <Grid item xs={12}>
                                        <Stack direction="row" spacing={1.5} justifyContent="flex-end" sx={{ mt: 1 }}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="secondary"
                                                onClick={handleClear}
                                                disabled={loading}
                                                sx={{ textTransform: 'none' }}
                                            >
                                                {t("text.Clear")}
                                            </Button>
                                            {/* ✅ Search button removed - auto filter enabled */}
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Card>
                    </Collapse>

                    {/* Search Box */}
                    <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-start' }} className="no-print">
                        <TextField
                            placeholder={t("text.Search") + "..."}
                            value={searchTerm}
                            onChange={handleSearch}
                            size="small"
                            sx={{ width: 300 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                    {/* Table Area */}
                    <TableContainer
                        component={Paper}
                        id="report-table-container"
                        sx={{
                            maxHeight: "65vh",
                            marginTop: 2,
                            border: "1px solid #ddd",
                            overflowX: 'auto',
                        }}
                    >
                        <Table stickyHeader aria-label="document manager reports table" sx={{ minWidth: 1000 }}>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center">{t("text.SrNo")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.FileName")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.deptName")}</StyledTableCell>
                                    {/* <StyledTableCell align="left">{t("text.Subject")}</StyledTableCell> */}
                                    <StyledTableCell align="left">{t("text.FileNo")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.FileType")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.SubSubjectName")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.Date")}</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
                                            <CircularProgress />
                                            <Typography sx={{ marginTop: 1 }}>{t("text.LoadingData")}...</Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : error ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
                                            <Alert severity="error" sx={{ justifyContent: 'center' }}>{error}</Alert>
                                        </TableCell>
                                    </TableRow>
                                ) : filteredData.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
                                            <Typography>{searchTerm ? t("text.NoMatchingResults") : t("text.NoReportsFound")}</Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    filteredData
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row: any, index: number) => (
                                            <Row
                                                key={row.docMid || index}
                                                row={row}
                                                index={page * rowsPerPage + index}
                                                onRowClick={handleRowClick}
                                            />
                                        ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Pagination */}
                    {!loading && filteredData.length > 0 && (
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            component="div"
                            count={filteredData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            sx={{ mt: 2 }}
                            className="no-print"
                        />
                    )}
                </Paper>
            </Card>

            {/* Details Drawer */}
            <DocMngSwipeableDrawer
                open={detailsDrawerOpen}
                onClose={handleDetailsDrawerClose}
                title={selectedRow ? `# ${selectedRow?.synopsis || 'N/A'} ${t('text.Details')}` : t('text.DocumentManager')}
                userData={selectedRow}
            />

            {/* PDF Preview Modal */}
            <PdfPreviewModal
                open={pdfModalOpen}
                onClose={() => setPdfModalOpen(false)}
                data={filteredData}
                filters={currentFilters}
                totalRecords={filteredData.length}
                logo={loged}
                optionDivision={optionDivision}
                optionSubSubject={optionSubSubject}
                optionFileType={optionFileType}
                optionSubDepartment={optionSubDepartment}
            />
        </>
    );
}